import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/ShiftPlansActions";
import * as api from "../../api/ShiftPlansApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getShiftPlans(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getShiftPlans(action.payload);
        yield put(actions.setShiftPlans(data || undefined));
    } catch (error) {
        yield put(actions.setShiftPlans(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addShiftPlan(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addShiftPlan(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateShiftPlan(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateShiftPlan(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteShiftPlan(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteShiftPlan(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_SHIFTPLANS, getShiftPlans);
    yield takeEvery(actions.Types.ADD_SHIFTPLAN, addShiftPlan);
    yield takeEvery(actions.Types.UPDATE_SHIFTPLAN, updateShiftPlan);
    yield takeEvery(actions.Types.DELETE_SHIFTPLAN, deleteShiftPlan);
}

const ShiftPlanSaga = [fork(watchAll)];

export default ShiftPlanSaga;
